<div class="scheduler-content">
	<div style="font-size: 28px; font-weight: 700; color: var(--green)">
		@if (saveObj?.date) {
			{{ "to_meeting_request" | langVal }}
		} @else {
			{{ "to_meeting-request_no_calendar" | langVal }}
			<h4>{{ "leave_details" | langVal }}</h4>
		}
	</div>
</div>
@if (isSummary) {
	@if (saveObj?.date) {
		<div>
			<div class="green-stripe">
				<p>
					{{ "your_meeting_details" | langVal }}
					{{ $safeNavigationMigration(saveObj?.date) | dateFormat: true }}
					{{ "at" | langVal }} {{ saveObj?.time }} {{ "accepted" | langVal }}.
				</p>
			</div>
			@if (links?.length) {
				<div class="green-stripe">
					<p>
						@for (link of links; track link) {
							<a
								[href]="link"
								target="_blank"
								>{{ "please_pay_ahead" | langVal }}</a
							>
						}
					</p>
				</div>
			}
			<div class="green-stripe">
				<p>
					{{ "confirmation_sent" | langVal }}
				</p>
			</div>
			<div class="green-stripe">
				<!--      <p>{{"see_you_on" | langVal}}{{saveObj?.date | dateFormat: true}}, </p>-->
				<!--      <p>  {{dataObj?.title}}{{dataObj?.name}}</p> -->
				<p>{{ "the_request_will_be_verified" | langVal }}</p>
			</div>
			<div class="green-stripe mis-auto">
				<!--      <p>{{"see_you_on" | langVal}}{{saveObj?.date | dateFormat: true}}, </p>-->
				<!--      <p>  {{dataObj?.title}}{{dataObj?.name}}</p> -->
				<p>{{ dataObj?.title }} {{ dataObj?.name }}</p>
			</div>
		</div>
	} @else {
		<div class="green-stripe">
			<p>{{ "meeting_request_was_sent" | langVal }}{{ dataObj?.name }}</p>
		</div>
	}
} @else {
	@if (saveObj?.date) {
		<div class="green-stripe">
			<p>
				{{ "meeting_details" | langVal }}
				{{ $safeNavigationMigration(saveObj?.date) | dateFormat: true }}
				{{ $safeNavigationMigration(saveObj?.date) | dateFormat }}
				{{ "at" | langVal }}
				{{ saveObj?.time }}
			</p>
		</div>
	}
	<div class="scheduler-content">
		<div>
			<label>{{ "name" | langVal }}</label>

			<app-gen-input
				tabindex="1"
				autocomplete="off"
				autofocus="autofocus"
				[actualObj]="actualObj"
				[errors]="errors"
				fieldName="name"
				(keyupEvent)="validateEntireForm()"
			/>
		</div>
	</div>
	<div class="scheduler-content">
		<div>
			<label>{{ "phone" | langVal }}</label>

			<app-gen-input
				tabindex="2"
				[actualObj]="actualObj"
				[errors]="errors"
				fieldName="phone"
				(keyupEvent)="validateEntireForm()"
			/>
		</div>
	</div>
	<div class="scheduler-content">
		<div>
			<label>{{ "email_not_must" | langVal }}</label>

			<app-gen-input
				tabindex="2"
				[actualObj]="actualObj"
				[errors]="errors"
				fieldName="email"
				(keyupEvent)="validateEntireForm()"
			/>
		</div>
	</div>
	<div class="scheduler-content">
		<div>
			<label>{{ "remarks" | langVal }}</label>

			<app-gen-input
				tabindex="3"
				type="textarea"
				[actualObj]="actualObj"
				[errors]="errors"
				fieldName="remarks"
				(keyupEvent)="validateEntireForm()"
			/>
		</div>
	</div>

	<div class="scheduler-content">
		<div
			class="pointer my-2"
			titleLang="by_clicking_i_agree"
		>
			<input
				class="agree-to-terms"
				type="checkbox"
				[(ngModel)]="actualObj.agree_to_terms"
				[checked]="actualObj.agree_to_terms"
				(change)="validateEntireForm()"
			/>
			<span
				class="text-agree"
				(click)="isTermsOpen = true"
				style="margin-inline: 5px"
			>
				{{ "by_clicking_i_agree" | langVal }} {{ "to_terms" | langVal }}</span
			>
		</div>
		@if (errors.agree_to_terms) {
			<p class="error">{{ errors.agree_to_terms }}</p>
		}
	</div>

	<div class="scheduler-content d-flex justify-content-end">
		<div class="modal-btns w-100">
			<app-btn-ext
				[text]="
					dataObj?.meeting_request_with_calendar
						? 'to_set_the_appointment'
						: 'to_send_the_request'
				"
				[disabled]="!isFormSubmittable"
				tabindex="10"
				(clickEv)="save()"
				[isSpin]="isSaving"
				class="w-100"
			/>
		</div>
	</div>
}

@if (showBack && isMobile) {
	<button
		class="btn btn-icon btn-back"
		(click)="backEv.emit(isSummary)"
		icon="back"
	></button>
}
@if (isTermsOpen) {
	<app-modal-wrap
		(onClose)="isTermsOpen = false"
		title="terms"
		modalWrapperClass="modal-wide"
	>
		<app-terms (onClose)="isTermsOpen = false" />
	</app-modal-wrap>
}
